import { MtBillingHistory, MtCart, MtPackage } from "server/models"
import { inferLiteral } from "client/utils"
import * as types from "./types"


export const setBillingStripePromise = (stripePromise: any) => ({
    type: inferLiteral(types.BILLING_STRIPE_PROMISE),
    stripePromise,
})

export const setBillingAvailablePackages = (packages: readonly MtPackage[]) => ({
    type: inferLiteral(types.BILLING_AVAILABLE_PACKAGES),
    packages,
})

export const setBillingHistory = (history: readonly MtBillingHistory[]) => ({
    type: inferLiteral(types.BILLING_HISTORY),
    history,
})
export const setBillingReloadHistory = (value: boolean) => ({
    type: inferLiteral(types.BILLING_RELOAD_HISTORY),
    value,
})

export const setBillingCart = (cart: readonly MtCart[]) => ({
    type: inferLiteral(types.BILLING_CART),
    cart,
})
export const setBillingReloadCart = (value: boolean) => ({
    type: inferLiteral(types.BILLING_RELOAD_CART),
    value,
})
